import {
  RPC_SERVER_RUNNING,
} from './mutation-types';

export default {
  [RPC_SERVER_RUNNING](state, payload) {
    state.rpcServerRunning = payload;
  },
};
